import React from "react";
import style from "./style.module.css";
import Loading from "views/components/loading";
import easilLoader from "./easil-loader.gif";

const FullPageLoading = ({ type = "spinner", backgroundColor = "#EDEDEE" }) => {
  const vectorsAnimation = (
    <img
      src={easilLoader}
      style={{ width: "100px", height: "100px" }}
      alt="vectors animation"
    />
  );

  const types = {
    spinner: <Loading />,
    vectors: vectorsAnimation
  };
  const animation = types[type];

  return (
    <div
      className={style.center}
      data-testid="FullPageLoading"
      style={{ backgroundColor }}
    >
      {animation}
    </div>
  );
};

export default FullPageLoading;
